import Weight, { WeightUnit } from '../../../components/dnd/inventory/Weight';
import EncumbranceStatus from '../../../components/dnd/inventory/EncumbranceStatus';

type StatsProps = {
    weight: number;
    weightLimit: number;
    weightUnit: WeightUnit;
    onWeightUnitChange: (unit: WeightUnit) => void;
};

function Stats({
    weight,
    weightLimit,
    weightUnit,
    onWeightUnitChange,
}: StatsProps) {
    return (
        <div className="row align-items-center">
            <div className="col d-flex align-items-center gap-3 flex-wrap">
                <span>
                    <strong>Weight:</strong>{' '}
                    <Weight value={weight} unit={weightUnit} />

                    {weightLimit !== undefined && (
                        <span>
                            {' / '}
                            <Weight
                                value={weightLimit}
                                unit={weightUnit}
                            />
                        </span>
                    )}
                </span>

                <div className="btn-group btn-group-sm" role="group" aria-label="Weight unit">
                    <button
                        type="button"
                        className={`btn btn-outline-secondary ${weightUnit === 'lb' ? 'active' : ''}`}
                        aria-pressed={weightUnit === 'lb'}
                        onClick={() => onWeightUnitChange('lb')}
                    >
                        lb
                    </button>
                    <button
                        type="button"
                        className={`btn btn-outline-secondary ${weightUnit === 'kg' ? 'active' : ''}`}
                        aria-pressed={weightUnit === 'kg'}
                        onClick={() => onWeightUnitChange('kg')}
                    >
                        kg
                    </button>
                </div>

                <EncumbranceStatus
                    currentWeight={weight}
                    maxWeight={weightLimit}
                />
            </div>
        </div>
    );
}

export default Stats;
